export default {
  brand: {
    name: 'USFansLink',
    tagline: 'Centre de ressources du spreadsheet',
  },
  nav: {
    home: 'Accueil',
    shoppingGuide: "Guide d'achat",
    articles: 'Articles',
    qc: 'Guide QC',
    shipping: 'Livraison',
    faq: 'FAQ',
    browse: 'Parcourir les catégories',
  },
  buttons: {
    buyNow: 'Acheter maintenant',
    explore: 'Explorer le spreadsheet USFans',
    browseGuides: 'Voir les guides produits',
    readMore: 'Lire le guide',
    backHome: 'Retour à l\'accueil',
    viewAll: 'Voir toutes les catégories',
    continue: 'Continuer vers le site principal',
  },
  footer: {
    about: 'USFansLink.site est une ressource d\'information indépendante sur le spreadsheet USFans. Nous aidons les acheteurs à trouver des liens produits, des infos QC, des guides de livraison et des conseils d\'achat sûrs.',
    quickLinks: 'Liens rapides',
    categories: 'Catégories',
    resources: 'Ressources',
    language: 'Langue',
    disclaimer: 'Avertissement : les liens externes, produits, prix, informations de livraison et promotions peuvent changer. Vérifiez toujours les informations actuelles avant tout achat ou paiement.',
    copyright: 'Tous droits réservés.',
  },
};